import PageShareButtons from 'components/Page/Page.ShareButtons'
import React from 'react'
import isAfterAQuarterOfTheArticleUtil from 'pages/Article/Content/utils/is-after-a-quarter-of-the-article/index.js'
import { logUtil } from 'packages/src'

/**
 * @param props
 * @param props.isImage
 * @param props.index
 * @param props.pb
 * @param props.hasShareButtons
 * @param props.hasRenderedShareAfterImageRef
 * @param props.chunksCount
 * @param props.img
 * @param props.title
 * @param props.url
 * @constructor
 */
export function ArticleContentShare (props) {
  const {
    isImage,
    index,
    pb,
    hasShareButtons,
    hasRenderedShareAfterImageRef,
    chunksCount,
    title,
    url,
    img
  } = props

  logUtil('ArticleContentShare').debug('props=', props)

  if (!hasShareButtons) {
    logUtil('ArticleContentShare').debug('[noop] no share buttons')
    return <></>
  }

  if (
    isImage &&
    hasRenderedShareAfterImageRef.current
  ) {
    logUtil('ArticleContentShare').debug('[noop] already rendered share buttons after image')
    return <></>
  }

  if (
    isImage &&
    !isAfterAQuarterOfTheArticleUtil({
      index,
      chunksCount
    })
  ) {
    logUtil('ArticleContentShare').debug('[noop] not 25% of the article')
    return <></>
  }

  if (isImage) {
    hasRenderedShareAfterImageRef.current = true
  }

  return (
    <PageShareButtons
      title={title}
      url={url}
      img={img}
      style={{ paddingBottom: pb }}
    />
  )
}
